import { useEffect, useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './style/MinimizeButton.css';

const MinimizeButton = () => {
	const [panelVisible, setPanelVisible] = useState(true);
	const PANEL_WIDTH = 400;

	const togglePanel = () => {
		const panelEl = document.querySelector('.painel-filtro');
		if (!panelEl) return;

		if (panelVisible) {
			panelEl.style.transform = 'translateX(-110%)';
			panelEl.style.transition = 'transform 0.6s ease';
		} else {
			panelEl.style.transform = 'translateX(0)';
			panelEl.style.transition = 'transform 0.6s ease';
		}

		setPanelVisible(!panelVisible);
	};

	useEffect(() => {
		const panelEl = document.querySelector('.painel-filtro');
		if (panelEl) {
			panelEl.style.transition = 'transform 0.6s ease';
			panelEl.style.transform = 'translateX(0)';
		}
	}, []);

	return (
		<div
			className="minimize-button-container"
			style={{ left: panelVisible ? `${PANEL_WIDTH}px` : '10px' }}
		>
			<button
				onClick={togglePanel}
				className="minimize-button"
				title={panelVisible ? 'Esconder painel' : 'Mostrar painel'}
			>
				{panelVisible ? <FaChevronLeft /> : <FaChevronRight />}
			</button>
		</div>
	);
};

export default MinimizeButton;
